import { tv } from '@change/ds-utils';

export const modalBody = tv({
	base: 'pt-2 pb-6',
});

export const contentColumn = tv({
	base: 'flex flex-1 flex-col gap-4',
});
